const library = require('@safe-systems/ss-ui-components');

const { copy } = library;

export default function CACustomerServiceDirectiveController(
  $q,

  alerts,
  loaderService,
  orgDataService,
  ssDialogService,
  beginServiceTrialDialog
) {
  const vm = this;

  vm.handleServiceIsActiveInputChange = _handleServiceIsActiveInputChange;
  vm.handleShowBeginServiceTrialDialogClick = _handleShowBeginServiceTrialDialogClick;

  function _handleServiceIsActiveInputChange() {
    loaderService.showViewLoader = true;
    orgDataService.saveCustomerService(vm.customerService)
      .then(() => {
        alerts.success(copy.admin.customerAdministration.alerts.enableDisableServiceSuccessful
          .text(vm.customerService.isActive));
        loaderService.showViewLoader = false;
      });
  }

  function _handleShowBeginServiceTrialDialogClick($event) {
    ssDialogService.dialogs.admin.beginServiceTrialDialog = ssDialogService.alert(
      beginServiceTrialDialog.getOptions($event, {
        serviceId: vm.customerService.serviceId,
        customerId: vm.customerService.customerId,
      })
    );
    return ssDialogService.show(ssDialogService.dialogs.admin.beginServiceTrialDialog);
  }
}

CACustomerServiceDirectiveController.$inject = [
  '$q',

  'alerts',
  'loaderService',
  'orgDataService',
  'ssDialogService',

  'beginServiceTrialDialog'
];
